// extracted by mini-css-extract-plugin
export default {"container":"oE-z","dimension":"pE-z","dimensionLabels":"qE-z"};